import SearchBar from './SearchBar.view';

export default SearchBar;
